import cx from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { Form } from './form';

const StyledClickableCard = styled.button<{ status?: ClickableCard.Status; variant?: string }>`
  &.x-pseudo {
    border: 2px solid
      ${({ status, variant }): string =>
        status ? `var(--${status})` : variant ? `var(--${variant})` : 'transparent'};
    border-radius: var(--border-radius-sm);
    position: relative;

    .indicator {
      position: absolute;
      top: -10px;
      right: -10px;
      margin-right: 0;
    }
  }
`;

type Props = React.PropsWithChildren<{
  className?: string;
  status?: ClickableCard.Status;
  variant?: string;
  type?: 'button' | 'reset' | 'submit' ;
  disabled?: boolean;
  name?: string;
  onClick?: () => void;
}>;

export namespace ClickableCard {
  export enum Status {
    Error = 'danger',
    Active = 'primary',
    Success = 'success'
  }

  export const Button = ({ className, children, status, type, name, ...rest }: Props): React.ReactElement =>{

    const field = Form.Utils.useField(name ?? '');

    const hasError = name ? Boolean(field?.meta.error) : false;

    // Force error styling if there's a validation error
    const finalStatus = hasError ? Status.Error : status;

    return (
      <StyledClickableCard
        key={`${name}-${hasError ? 'true' : 'false'}`}
        className={cx(className, 'x-pseudo', 'grid-item')}
        type={type}
        status={finalStatus}
        {...rest}
      >
        {finalStatus === Status.Error ? (
          <span>
            <i className='fas fa-exclamation-circle indicator bg-white text-danger font-size-20px' />
          </span>
        ) : finalStatus === Status.Success ? (
          <span>
            <i className='fas fa-check-circle indicator bg-white text-success font-size-20px' />
          </span>
        ) : finalStatus === Status.Active && (
          <span>
            <i className='fas fa-check-circle indicator bg-white text-primary font-size-20px' />
          </span>
        )}
        {children}
      </StyledClickableCard>

    );
  };
}
